import { ShippingMethodDictionaryResponse } from '../api/responses';
import { ShippingMethodDictionary } from '../models/shipping-method-dictionary';

export const shippingMethodDictionaryFromResponse = (
  response: ShippingMethodDictionaryResponse,
) =>
  new ShippingMethodDictionary({
    code: response.code,
    name: response.name,
    id: response.id,
  });
